// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_eu-6";
export var emphasizeQuantity = "_eu-3";
export var flatBottomCorners = "_eu-5";
export var productImage = "_eu-0";
export var quantityContainer = "_eu-2";
export var tooltip = "_eu-1";
export var wrapAndEllipsesOverflow = "_eu-4";